import { AxiosResponse } from 'axios';

export const asyncPayloadCreator = async (
	credentials: any | undefined,
	{ rejectWithValue }: any,
	apiCall: (data: any) => Promise<AxiosResponse<unknown>>,
) => {
	try {
		return await apiCall(credentials);
	} catch (e: any) {
		return rejectWithValue(e?.response.data);
	}
};
